// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"5315":"c25bc40dd61746b63446","5706":"3153330af47fc26a725a","6127":"374a617a5ed71ccd7362"}[chunkId] + "";
};